import { mergeStyles, Separator, Stack, TextField, Toggle } from '@fluentui/react';

import { actions } from '../../../slice';
import { Payment } from '../../../slice/newFormReducers';
import { useColumnOnChangeFn, useColumnSelector } from './hooks';

type Props = {
  uuid: string;
};

const key: keyof Payment = "installments";
const oneTimeValue = "Tek Çekim";

export default ({ uuid }: Props) => {
  const paymentType = useColumnSelector(uuid, "type");

  const isEditingLocked = useColumnSelector(uuid, "isEditingLocked");
  const value = useColumnSelector(uuid, key);
  const onChange = useColumnOnChangeFn(uuid, key);

  if (paymentType !== "credit-card") {
    return <Separator />;
  }

  const isOneTime = value === oneTimeValue;

  return (
    <Stack horizontal verticalAlign="center" tokens={stackTokens}>
      <Toggle
        inlineLabel
        className={toggleStyles}
        checked={isOneTime}
        disabled={isEditingLocked}
        label={isOneTime ? "Tek Çekim" : "Taksitli"}
        onChange={(_, toggled) =>
          actions.setFormPaymentVariable([
            uuid,
            key,
            toggled ? oneTimeValue : "",
          ])
        }
      />
      {!isOneTime && (
        <TextField
          placeholder="Örnek: 6 + 3"
          value={value || ""}
          onChange={onChange}
          maxLength={7}
          disabled={isEditingLocked || isOneTime}
        />
      )}
    </Stack>
  );
};

const stackTokens = { childrenGap: 10 };
const toggleStyles = mergeStyles({
  margin: "0",
});
